import { render } from "./AsCourses.vue?vue&type=template&id=bb7d85c0&ts=true"
import script from "./AsCourses.vue?vue&type=script&lang=ts"
export * from "./AsCourses.vue?vue&type=script&lang=ts"

import "./AsCourses.vue?vue&type=style&index=0&id=bb7d85c0&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__